/*
  COREEX expert video.

  One video per section, click to play with sound. No autoplay and no
  IntersectionObserver: this is a talking-head explainer, so it waits to be
  asked.

  The .is-playing class is driven by the media element's own play / pause /
  ended events rather than by the click, so the button stays correct when the
  video finishes on its own or is paused from the native controls.

  Pausing every OTHER expert video on the page keeps two of these sections from
  talking over each other — cheap to do, and the alternative is a support
  ticket.
*/
(function () {
  'use strict';

  function initExpertVideo(wrapper) {
    if (wrapper.dataset.coreexReady === 'true') return;
    wrapper.dataset.coreexReady = 'true';

    var video = wrapper.querySelector('.coreex-expert__video');
    var button = wrapper.querySelector('.coreex-expert__play');
    if (!video || !button) return;

    video.playsInline = true;

    button.addEventListener('click', function (event) {
      event.preventDefault();

      if (video.paused) {
        pauseOthers(video);

        var played = video.play();
        if (played && played.catch) {
          played.catch(function () {
            /* Some browsers refuse an unmuted play if the click was not
               recognised as a gesture. Falling back to muted is better than a
               button that looks broken; the visitor can unmute from the native
               controls. */
            video.muted = true;
            video.play().catch(function () {});
          });
        }
      } else {
        video.pause();
      }
    });

    video.addEventListener('play', function () {
      wrapper.classList.add('is-playing');
      /* Controls are deliberately withheld until first play, so the poster and
         the custom button are not competing with a native control bar. */
      video.controls = true;
    });

    video.addEventListener('pause', function () {
      wrapper.classList.remove('is-playing');
    });

    video.addEventListener('ended', function () {
      wrapper.classList.remove('is-playing');
      video.controls = false;
    });
  }

  function pauseOthers(current) {
    var all = document.querySelectorAll('.coreex-expert__video');
    Array.prototype.forEach.call(all, function (other) {
      if (other === current) return;
      other.pause();
    });
  }

  function initAll(scope) {
    var target = scope || document;
    Array.prototype.forEach.call(
      target.querySelectorAll('.coreex-expert__video-wrapper'),
      initExpertVideo
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  /* Theme editor: a re-rendered section arrives as fresh DOM with no
     listeners. The dataset guard above stops untouched ones initialising a
     second time. */
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
